import { useQuery } from "@tanstack/react-query";

import { getPartnerModulesPartnerID } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PARTNERS_QUERY_KEYS } from "./queryKeys";

const DEFAULT_LIMIT = 1000;
const DEFAULT_OFFSET = 0;

export function usePartnerModulesQuery(partnerID?: string) {
  return useQuery({
    queryKey: PARTNERS_QUERY_KEYS.modules(partnerID!),
    queryFn: processResponse(() =>
      getPartnerModulesPartnerID(partnerID!, DEFAULT_OFFSET, DEFAULT_LIMIT),
    ),
    enabled: !!partnerID,
  });
}
